import $ from 'jquery';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Form from 'root/module/form';
import View from 'view/base';

export default View.extend({
    className: 'onboarding-step-2',

    subdomain_changed: false,

    events: {
        'keyup input[name="display_name"]' : 'onChangeDisplayName',
        'keydown input[name="subdomain"]'  : 'onBeforeChangeSubdomain',
        'input input[name="subdomain"]'    : 'onChangeSubdomain',
        'click .back-btn'                  : 'onBack',
        'submit form'                      : 'onSubmit'
    },

    dom_handlers: {
        onChangeDisplayName: function(e) {
            var form_data = Form.getData(this.$el.find('form'));

            if (!form_data.subdomain || !this.subdomain_changed) {
                var subdomain_sanitised = Util.sanitizeCustomSubdomain(form_data.display_name.substring(0, 30)); // maxlength: 30

                Form.setData(this.$el.find('form'), {
                    subdomain: subdomain_sanitised
                });

                clearTimeout(this.subdomain_timeout);
                this.subdomain_timeout = setTimeout(() => {
                    this.checkSubdomain(subdomain_sanitised);
                }, 100);
            }

            this.checkFormChange();
        },

        onBeforeChangeSubdomain: function(e) {
            if (!e.key || !e.key.match(/[a-zA-Z0-9-]/)) {
                e.preventDefault();
                return;
            }
        },

        onChangeSubdomain: function(e) {
            var subdomain = $(e.currentTarget).val().trim();

            var subdomain_sanitised = Util.sanitizeCustomSubdomain(subdomain);

            if (subdomain !== subdomain_sanitised) {
                $(e.currentTarget).val(subdomain_sanitised);
            }

            if (!subdomain_sanitised) {
                this.$el.find('.url-taken').hide();
                this.$el.find('.url-validation').html('');
                return;
            }

            if (subdomain_sanitised !== this.model.get('subdomain')) {
                clearTimeout(this.subdomain_timeout);
                this.subdomain_timeout = setTimeout(() => {
                    this.checkSubdomain(subdomain_sanitised);
                }, 100);
            }

            this.subdomain_changed = true;

            this.checkFormChange();
        },

        onBack: function() {
            this.trigger('back');
        },

        onSubmit: function(e) {
            var form_data = Form.getData(this.$el.find('form'));

            // do not submit is nothing changes
            if (this.model.get('subdomain') === form_data.subdomain &&
                this.model.get('display_name') === form_data.display_name) {

                this.trigger('complete');
                return;
            }

            this.$el.find('form button:submit').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'workspace/update',
                data: {
                    workspace_id : this.model.id,
                    subdomain    : form_data.subdomain,
                    display_name : form_data.display_name,
                    onboarding   : true
                },
                error: () => {
                    this.renderSubdomainValidation(false, form_data.subdomain);
                },
                success: (response) => {
                    this.model.set(response);

                    this.trigger('complete');
                },
                complete: () => {
                    this.$el.find('form button:submit').removeClass('loading').prop('disabled', false);
                }
            });
        }
    },

    initialize: function() {
        this.model = Cache.getDefaultWorkspace();
    },

    checkFormChange: function() {
        var form_data = Form.getData(this.$el.find('form'));

        this.$el.find('button:submit').prop('disabled', !form_data.display_name || !form_data.subdomain);
    },

    checkSubdomain: function(subdomain, on_render) {
        // no server side check is needed when the saved domain is loaded in the UI
        if (subdomain === this.model.get('subdomain')) {
            this.renderSubdomainValidation(true, subdomain);
            return;
        }

        this.$el.find('.url-validation').html('<i class="far fa-sync-alt fa-spin text-info"></i>');

        Cache.app.request({
            action: 'workspace/checkSubdomain',
            data: {
                subdomain: subdomain
            },
            error: () => {
                if (on_render) {
                    this.$el.find('.url-validation').hide();
                    this.$el.find('.url-taken').hide();
                } else {
                    this.renderSubdomainValidation(false, subdomain);
                }
            },
            success: () => {
                this.renderSubdomainValidation(true, subdomain);
            }
        });
    },

    renderSubdomainValidation(success, subdomain) {
        if (!subdomain) {
            this.$el.find('.url-validation').hide();
            this.$el.find('.url-taken').hide();
            return;
        }

        if (success) {
            this.$el.find('.url-validation').html('<i class="far fa-check text-success"></i>').show();
            this.$el.find('.url-taken').hide();
        } else {
            this.$el.find('.url-validation').html('<i class="far fa-times text-danger"></i>').show();
            this.$el.find('.url-taken').show();
        }
    },

    render: function() {
        var content =
        '<h1 class="text-align-center"><b>Set up your workspace</b></h1>' +
        '<p class="text-align-center margin-bottom-32">Workspace is the home of your projects</p>' +
        '<form class="form-fluid">' +
            '<div class="row">' +
                '<div class="field-label">Workspace name</div>' +
                '<input class="solid medium" type="text" name="display_name" maxlength="100" placeholder="e.g. My Company" required>' +
            '</div>' +
            '<div class="row">' +
                '<div class="field-label">Workspace URL</div>' +
                '<div class="input-subdomain">' +
                    '<div>' +
                        '<span class="url-validation"><i class="far fa-check text-success"></i></span>' +
                        '<span class="subdomain">' +
                            '<input type="text" name="subdomain" maxlength="30" data-validation="string" spellcheck="false" placeholder="mycompany" required>' +
                        '</span>' +
                        '<span class="host-name">' + Cache.app.configs.workspace_host + '</span>' +
                    '</div>' +
                '</div>' +
                '<div class="url-taken">This url is already taken</div>' +
            '</div>' +
            '<div class="onboarding-footer">' +
                '<div><button type="button" class="back-btn tertiary small min">Back</button></div>' +
                '<div>2 of 3</div>' +
                '<div><button type="submit" class="primary small min" disabled>Next</button></div>' +
            '</div>' +
        '</form>';

        this.$el.html(content);

        Form.setData(this.$el.find('form'), {
            subdomain: this.model.get('subdomain'),
            display_name: this.model.get('display_name')
        });

        this.checkSubdomain(this.model.get('subdomain'), true);
        this.checkFormChange();

        return this;
    }
});